import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-faq-rivoneed';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Buy Now',
  backgroundColor: '#ff0000',
  color: '#ffffff',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});
const html = `
<div class="container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">STILL HAVE A QUESTION?</h2>
    <p style="text-align: center">View our FAQ</p>
  </div>
  <div class="block-accordion">
    <div data-attribute="card-accordions" data-show-accordion="true" style="display: block">
      <div data-attribute="card-accordion" class="wrap-accordion">
        <div data-attribute="accordion-title" class="accordion-title">
          <div data-attribute="accordion-title-text">Will this attach to my car?</div>

          <div class="accordion-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-down-icon lucide-chevron-down"
            >
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </div>
        </div>
        <div data-attribute="accordion-content" class="accordion-content" style="">
          <div data-attribute="accordion-text" class="accordion-text">
            <p>
              Yes. Magnets stick to most metal engine bay panels. For non-metal surfaces, use the built-in hook or
              clamp. Fits 99%+ of vehicles.
            </p>
          </div>
        </div>
      </div>

      <div data-attribute="card-accordion" class="wrap-accordion">
        <div data-attribute="accordion-title" class="accordion-title">
          <div data-attribute="accordion-title-text">Can I use it in the rain?</div>

          <div class="accordion-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-down-icon lucide-chevron-down"
            >
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </div>
        </div>
        <div data-attribute="accordion-content" class="accordion-content" style="">
          <div data-attribute="accordion-text" class="accordion-text">
            <p>
              Yes. IPX4 means it handles rain and splashes just fine. No problem if a sudden shower hits while you're
              working.
            </p>
          </div>
        </div>
      </div>

      <div data-attribute="card-accordion" class="wrap-accordion">
        <div data-attribute="accordion-title" class="accordion-title">
          <div data-attribute="accordion-title-text">Why does runtime range from 6 to 24 hours?</div>

          <div class="accordion-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-down-icon lucide-chevron-down"
            >
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </div>
        </div>
        <div data-attribute="accordion-content" class="accordion-content" style="">
          <div data-attribute="accordion-text" class="accordion-text">
            <p>
              It depends on brightness. Max white light runs about 6 hours. Lower brightness or switch to yellow or red
              light and you get up to 24 hours. Just pick what fits the job.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
</div>
`;
export default containerFuild(html, css);
